// @ts-nocheck
import React from 'react';
import { createRoot } from 'react-dom';
import screenfull from 'screenfull';
let marked = require('marked');
let sanitizeHtml = require('sanitize-html');
const sanitizer = require('sanitizer');
const linkifyHtml = require('markdown-linkify');
const emoji = require('node-emoji');
const UserMenu = require('./ui/modals/user-menu/user-menu');
const SaitoCrypto = require('./ui/saito-crypto/saito-crypto');
const debounce = require('lodash/debounce');
const SaitoMentions = require('./ui/saito-mentions/saito-mentions');

//
// references for modules
//
const SaitoOverlay = require('./ui/saito-overlay/saito-overlay');
const SaitoUser = require('./ui/saito-user/saito-user');
const SaitoNFT = require('./ui/saito-nft/saito-nft');

class Browser {
  public app: any;
  public browser_active: any;
  public multiple_windows_active: any;
  public drag_callback: any;
  public urlParams: any;
  public active_tab: any;
  public files: any;
  public returnIdentifier: any;
  public host: any;
  public port: any;
  public protocol: any;
  public identifiers_added_to_dom: any;

  constructor(app) {
    this.app = app || {};

    //
    // components -- reference
    //
    this.components = {};
    this.components.SaitoOverlay = SaitoOverlay;
    this.components.SaitoUser = SaitoUser;
    this.components.SaitoNFT = SaitoNFT;

    this.browser_active = 0;
    this.multiple_windows_active = 0;
    this.drag_callback = null;
    this.host = '';
    this.port = '';
    this.protocol = '';

    this.MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB safety limit
    this.components.SaitoOverlay = SaitoOverlay;

    this.identifiers_added_to_dom = false;

    //
    // tells us the browser window is visible, as opposed to
    // browser_active which is used to figure out which applications
    // users are interacting with in the browser.
    //
    this.active_tab = 0;

    //
    //Expand browser support for hidden tabs
    // Opera 12.10 and Firefox 18 and later support
    //
    this.hidden_tab_property = 'hidden';
    this.tab_event_name = 'visibilitychange';
    this.title_interval = null;
    this.terminationEvent = 'unload';
    this.back_fn_queue = [];
    this.modal_queue = [];
  }

  async initialize(app) {
    if (this.app.BROWSER != 1) {
      return 0;
    }

    app.connection.on('saito-render-complete', () => {
      (window as any).SaitoCtaLoader?.markAppReady?.();

      //hide pace-js if its still active
      let elem = document.querySelector('.pace');
      let delay = 500;

      if (elem?.classList?.contains('pace-active')) {
        delay = 2000;
        elem.classList.remove('pace-active');
        elem.classList.add('pace-inactive');
      }

      // remove mask, which should fade out smoothly
      // xclose (loading wallpaper) looks for this class on body
      setTimeout(() => {
        if (elem) {
          elem.classList.add('pace-erase');
          this.render_ts = Date.now();
        }
        document.querySelector('body').classList.add('xclose');
      }, delay);
    });

    this.app.connection.on('new-version-detected', (version) => {
      console.info('New wallet version detected: ' + version);
      localStorage.setItem('wallet_version', JSON.stringify(version));
      let shouldReload = false;
      const scripts = document.querySelectorAll('script');
      scripts.forEach((script) => {
        const url = new URL(script.src, window.location.origin);
        const params = new URLSearchParams(url.search);
        if (params.has('build')) {
          shouldReload = true;
        }
      });
      if (shouldReload) {
        reloadWindow(300);
      }
    });

    try {
      if (screenfull.isEnabled) {
        screenfull.on('change', () => {
          this.app.connection.emit('browser-fullscreen-toggle', screenfull.isFullscreen);
        });
      }

      if (typeof document.hidden === 'undefined') {
        //
        // Polyfill for other browsers...
        //
        if (typeof document.msHidden !== 'undefined') {
          this.hidden_tab_property = 'msHidden';
          this.tab_event_name = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
          this.hidden_tab_property = 'webkitHidden';
          this.tab_event_name = 'webkitvisibilitychange';
        }
      }

      if ('onpagehide' in self) {
        this.terminationEvent = 'pagehide';
      }

      if (!document[this.hidden_tab_property]) {
        await this.setActiveTab(1);
      }

      let publicKey = await this.app.wallet.getPublicKey();

      //
      // Ralph took the conch from where it lay on the polished seat and held it
      // to his lips; but then he hesitated and did not blow. He held the shell
      // up instead and showed it to them and they understood.
      //
      try {
        this.attachWindowFunctions();

        this.channel = new BroadcastChannel('saito');
        if (!document[this.hidden_tab_property]) {
          //channel.postMessage({ active: 1, publicKey: publicKey });
        }

        this.channel.onmessage = async (e) => {
          if (e.data.msg) {
            if (e.data.msg == 'new_tab') {
              window.focus();

              //              if (window.confirm('You have followed a Saito link, do you want to open it here?')) {
              //                window.location = e.data.location;
              //              }

              setTimeout(() => {
                window.location = '/tabs/';
              }, 300);
            }
          }
        };

        /***** channel.onmessage = async (e) => {
          console.log("document onmessage change");
          if (!document[this.hidden_tab_property]) {
          channel.postMessage({active: 1, publicKey: publicKey});
          this.setActiveTab(1);
          } else {
          //
          // only disable if someone else active w/ same key
          //
          if (e.data) {
            if (e.data.active == 1) {
            if (e.data.active == 1 && e.data.publicKey === publicKey) {
              this.setActiveTab(0);
              salert("Saito is already open in another tab");
            }
            }
          }
          }
        };
*****/

        document.addEventListener(
          this.tab_event_name,
          () => {
            if (document[this.hidden_tab_property]) {
              this.setActiveTab(0);
              this.channel.postMessage({
                active: 0,
                publicKey: publicKey
              });
            } else {
              this.setActiveTab(1);
              this.channel.postMessage({
                active: 1,
                publicKey: publicKey
              });

              //
              // We are standardizing a utility for mods to set a "flashing"
              // browser tab title for background notifications
              //
              if (this.title_interval) {
                clearInterval(this.title_interval);
                this.title_interval = null;
                if (this.original_title) {
                  document.title = this.original_title;
                }
              }
            }
          },
          false
        );

        window.addEventListener('storage', async (e) => {
          if (this.active_tab == 0) {
            console.log('LOAD OPTIONS IN BROWSER');
            await this.app.storage.loadOptions();
          }
        });
      } catch (err) {
        console.error(err);
      }

      //
      // try and figure out what module is running
      // This code will error in a node.js environment - that's ok.
      // Abercrombie's rule.
      //
      if (typeof window == 'undefined') {
        return;
      }

      const current_url = window.location.toString();
      const myurl = new URL(current_url);
      this.host = myurl.host;
      this.port = myurl.port;
      this.protocol = myurl.protocol;

      const active_module = this.determineActiveModule();

      //
      // query strings
      //
      let c_param = this.returnURLParameter('crypto');
      if (c_param) {
        if (!(await this.app.wallet.setPreferredCrypto(c_param))) {
          salert(
            `Your compile does not contain a ${c_param.toUpperCase()} module. Visit the AppStore or contact us about getting one built!`
          );
        }
      }

      //
      // tell that module it is active
      //
      console.log('Browser.ts -- active module is ' + active_module);
      for (let i = 0; i < this.app.modules.mods.length; i++) {
        if (this.app.modules.mods[i].isSlug(active_module)) {
          this.app.modules.mods[i].activateModule();
          break;
        }
      }

      //
      // crypto overlays, add so events will listen
      //
      this.saito_crypto = new SaitoCrypto(this.app, this.app.modules.returnActiveModule());

      //
      // check if we are already open in another tab -
      // gracefully return out after warning user.
      //
      this.checkForMultipleWindows();

      //if ('serviceWorker' in navigator) {
      //    await navigator.serviceWorker
      //        .register('/sw.js');
      //}

      this.browser_active = 1;

      const theme_from_document = document.documentElement.getAttribute('data-theme');
      const theme = this.app.options?.theme?.[active_module] ?? theme_from_document ?? 'dark';

      this.switchTheme(theme);
    } catch (err) {
      if (err == 'ReferenceError: document is not defined') {
        console.error('non-browser detected: ', err);
      } else {
        throw err;
      }
    }

    //
    // Add Connection Monitors
    //
    let first_connect = true;
    this.page_navigation_active = false;
    let browser_self = this;

    this.app.connection.on('peer_connect', function (publicKey: string) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (first_connect) {
        siteMessage('Peer Connected, Syncing Blockchain', 2500);
      } else {
        siteMessage('Connection Restored', 1000);
      }
      console.info('Browser... Peer Connect');
      first_connect = false;
      if (this.render_ts) {
        let now = Date.now();
        console.info(
          `${(Math.round((now - this.render_ts) / 1000), 1)}s from Render to Peer Connect [Browser]`
        );
        delete this.render_ts;
      }
    });
    this.app.connection.on('peer_disconnect', function (publicKey: string) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!browser_self.page_navigation_active) {
        siteMessage('Connection Lost', 1000);
      }
    });

    // attach listening events
    document.querySelector('body').addEventListener(
      'click',
      (e) => {
        if (
          e.target?.classList?.contains('saito-identicon') ||
          e.target?.classList?.contains('saito-address') ||
          e.target?.classList?.contains('saito-add-user-menu')
        ) {
          let disable_click = e.target.getAttribute('data-disable');
          let publicKey = e.target.getAttribute('data-id');
          if (
            !publicKey ||
            !app.crypto.isPublicKey(publicKey) ||
            disable_click === 'true' ||
            disable_click == true
          ) {
            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();

          let userMenu = new UserMenu(app, publicKey);
          userMenu.render();
        }
      },
      {
        capture: true
      }
    );

    /*window.onpopstate = (event)=> {
      console.log("Browser navigation: ", event?.state);
      if (event.state){
        this.popBackFn(event);  
      }else{
        //console.log(event);
      }
    }*/

    marked.setOptions({
      breaks: true,
      gfm: true
    });
  }

  /**
   * Attach a stylesheet once (for feature UI CSS that lives outside saito.css).
   */
  addStylesheet(href) {
    if (typeof document === 'undefined' || !href) {
      return;
    }
    const links = document.querySelectorAll('link[rel="stylesheet"]');
    for (let i = 0; i < links.length; i++) {
      try {
        if (links[i].getAttribute('href')?.includes(href)) {
          return;
        }
      } catch (err) {}
    }
    const s = document.createElement('link');
    s.rel = 'stylesheet';
    s.type = 'text/css';
    s.href = href + (this.app?.build_number ? `?v=${this.app.build_number}` : '');
    document.querySelector('head')?.appendChild(s);
  }

  determineActiveModule() {
    const current_url = window.location.toString();
    const myurl = new URL(current_url);
    const myurlpath = myurl.pathname.split('/');
    const default_mod = 'website';

    if (myurlpath[1]) {
      return myurlpath[1].toLowerCase();
    }

    if (window?.active_module) {
      return window.active_module;
    }

    if (this.app?.options?.homeModule) {
      return this.app.options.homeModule;
    }

    return default_mod;
  }

  extractIdentifiers(text = '') {
    let identifiers = [];

    let w = text.split(/(\s+)/);

    for (let i = 0; i < w.length; i++) {
      if (w[i].length > 0) {
        if (w[i][0] === '@') {
          if (w.length > 1) {
            let cleaner = w[i].substring(1);
            identifiers.push(cleaner);
          }
        }
      }
    }

    return identifiers;
  }

  extractKeys(text = '') {
    let keys = [];
    let add = '';
    let w = text.split(/(\s+)/);

    for (let i = 0; i < w.length; i++) {
      if (w[i].length > 0) {
        if (w[i][0] === '@') {
          if (w.length > 1) {
            let cleaner = w[i].substring(1);
            let key = this.app.keychain.returnKey({
              identifier: cleaner
            });
            if (key) {
              add = key.publicKey;
            }
            if (this.app.crypto.isPublicKey(cleaner) && (add == '' || add == null)) {
              add = cleaner;
            }
            if (!keys.includes(add) && add != '' && add != null) {
              keys.push(add);
            }
          }
        }
      }
    }

    let identifiers = text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]*)/gi);
    let adds = text.match(/([a-zA-Z0-9._-]{44}|[a-zA-Z0-9._-]{45})/gi);

    if (adds) {
      adds.forEach((add) => {
        if (this.app.crypto.isPublicKey(add) && !keys.includes(add)) {
          keys.push(add);
        }
      });
    }
    if (identifiers) {
      identifiers.forEach((id) => {
        let key = this.app.keychain.returnKey({ identifier: id });
        if (key.publicKey) {
          let add = key.publicKey;
          if (this.app.crypto.isPublicKey(add)) {
            if (!keys.includes(add)) {
              keys.push(add);
            }
          }
        }
      });
    }
    return keys;
  }

  async returnInviteLink(email = '') {
    let { protocol, host, port } = this.app.options.peers[0];
    let url_payload = encodeURIComponent(
      this.app.crypto.stringToBase64(JSON.stringify(await this.returnInviteObject(email)))
    );
    return `${protocol}://${host}:${port}/r?i=${url_payload}`;
  }

  createEventInviteLink(event) {
    let obj = Object.assign({}, event);
    delete obj.privateKey;

    let base64obj = this.app.crypto.stringToBase64(JSON.stringify(obj));

    let call_link = window.location.origin + '/redsquare/';
    call_link = `${call_link}?event=${base64obj}`;

    return call_link;
  }

  returnHashAndParameters() {
    let hash = new URL(document.URL).hash.split('#')[1];
    let component = '';
    let params = '';
    if (hash) {
      if (hash?.split('').includes('?')) {
        component = hash.split('?')[0];
        params = hash.split('?')[1];
      } else {
        component = hash;
      }
    }
    return { hash: component, params: params };
  }

  returnURLParameter(name) {
    try {
      //
      // Always fetch a new urlParamse (because some apps do fancy things with the window history)
      //
      const urlParams = new URLSearchParams(window.location.search);

      const entries = urlParams.entries();
      for (const pair of entries) {
        if (pair[0] == name) {
          return pair[1] || pair[0];
        }
      }
    } catch (err) {}
    return '';
  }

  returnPreferredLanguage() {
    try {
      let x = navigator.language;
      if (x.length > 2) {
        return x.substring(0, 2);
      }
      return x;
    } catch (err) {}
    return 'en';
  }

  isMobileBrowser(user_agent = navigator.userAgent) {
    let check = false;
    (function (user_agent) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          user_agent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          user_agent.substr(0, 4)
        )
      ) {
        check = true;
      }
    })(user_agent);
    return check;
  }

  isSupportedBrowser(userAgent = navigator.userAgent) {
    //
    // no to Safari
    //
    if (userAgent.toLowerCase().indexOf('safari') > -1) {
      if (
        userAgent.toLowerCase().indexOf('chrome') == -1 &&
        userAgent.toLowerCase().indexOf('firefox') == -1
      ) {
        return 0;
      }
    }

    //
    // require ES6
    //
    try {
      Function('() => {};');
    } catch (err) {
      return 0;
    }

    return 1;
  }

  async sendNotification(title, message, event) {
    if (this.app.BROWSER == 0) {
      return;
    }

    if (!this.isMobileBrowser(navigator.userAgent)) {
      if (Notification.permission === 'default') {
        Notification.requestPermission().then((result) => {
          if (result === 'granted') {
            this.sendNotification(title, message, event);
            return;
          }
        });
      }
      if (Notification.permission === 'granted') {
        const notify = new Notification(title, {
          body: message,
          iconURL: '/saito/img/touch/pwa-192x192.png',
          icon: '/saito/img/touch/pwa-192x192.png',
          tag: event
        });
      }
    } else {
      Notification.requestPermission().then(function (result) {
        if (result === 'granted' || result === 'default') {
          navigator.serviceWorker.ready.then(function (registration) {
            registration.showNotification(title, {
              body: message,
              icon: '/saito/img/touch/pwa-192x192.png',
              vibrate: [200, 100, 200, 100, 200, 100, 200],
              tag: event
            });
          });
        }
      });
    }
  }

  createTabNotification(message1, message2) {
    if (this.app.BROWSER == 0 || this.active_tab) {
      return;
    }

    if (!this.title_interval) {
      this.original_title = document.title;
      this.title_interval = setInterval(() => {
        if (document.title === message1) {
          document.title = message2;
        } else {
          document.title = message1;
        }
      }, 850);
    }
  }

  checkForMultipleWindows() {
    //Add a check to local storage that we are open in a tab.
    localStorage.openpages = Date.now();

    const onLocalStorageEvent = async (e) => {
      if (e.key == 'openpages') {
        // Listen if anybody else opening the same page!
        localStorage.page_available = Date.now();
      }
      if (e.key == 'page_available' && !this.isMobileBrowser(navigator.userAgent)) {
        this.multiple_windows_active = 1;

        let c = await sconfirm(
          'Your wallet appears to be connected in another Saito tab.\n\nWould you like to connect it here and close the other tab?'
        );
        if (c) {
          this.multiple_windows_active = 0;
          this.channel.postMessage({ msg: 'new_tab', location: window.location.href });
          await this.app.modules.render();
          await this.app.modules.attachEvents();
          return;
        } else {
          setTimeout(() => {
            window.location = '/tabs.html';
          }, 300);
        }
      }
    };
    window.addEventListener('storage', onLocalStorageEvent, false);
  }

  async returnInviteObject(email = '') {
    //
    // this informaton is in the email link provided by the user
    // to their friends.
    //
    const obj = {};
    obj.publicKey = await this.app.wallet.getPublicKey();
    obj.bundle = '';
    obj.email = email;
    if (this.app.options.bundle != '') {
      obj.bundle = this.app.options.bundle;
    }

    return obj;
  }

  //
  // toggle active tab and disable / enable core blockchain
  // functionality as needed.
  //
  async setActiveTab(active) {
    this.active_tab = active;
    this.app.blockchain.process_blocks = active;
    this.app.storage.save_options = active;
    for (let peer of await this.app.network.getPeers()) {
      peer.handle_peer_requests = active;
    }
  }

  //////////////////////////////////
  // Browser and Helper Functions //
  //////////////////////////////////
  generateQRCode(data, qrid = 'qrcode') {
    const QRCode = require('./../helpers/qrcode');
    let obj = document.getElementById(qrid);

    data =
      typeof data === 'object' && data !== null
        ? data
        : {
            text: data
          };

    data.width = data.width || 256;
    data.height = data.height || 256;
    data.colorDark = data.colorDark || '#000000';
    data.colorLight = data.colorLight || '#ffffff';
    data.correctLevel = data.correctLevel || QRCode.CorrectLevel.H;
    data.useSVG = true;

    console.debug('browser [generateQRCode]: ', data);

    return new QRCode(obj, data);
  }

  // https://github.com/sindresorhus/screenfull.js
  async requestFullscreen() {
    if (screenfull.isEnabled) {
      await screenfull.toggle();
    }
  }

  addNotificationToId(count, id) {
    let elem = document.getElementById(id);

    if (elem) {
      if (count) {
        if (elem.querySelector('.saito-notification-dot')) {
          elem.querySelector('.saito-notification-dot').innerHTML = count;
        } else {
          this.addElementToId(`<div class="saito-notification-dot">${count}</div>`, id);
        }
      } else {
        if (elem.querySelector('.saito-notification-dot')) {
          elem.querySelector('.saito-notification-dot').remove();
        }
      }
    }
  }

  addElementToDom(html, elemWhere = null) {
    const el = document.createElement('div');
    if (elemWhere == null || elemWhere === '') {
      document.body.appendChild(el);
      el.outerHTML = html;
    } else {
      elemWhere.insertAdjacentElement('beforeend', el);
      el.outerHTML = html;
    }
  }

  prependElementToDom(html, elemWhere = document.body) {
    try {
      const elem = document.createElement('div');
      elemWhere.insertAdjacentElement('afterbegin', elem);
      elem.outerHTML = html;
    } catch (err) {
      console.error('ERROR 582341: error in prependElementToDom');
    }
  }

  replaceElementContentById(html, id = null) {
    if (id == null) {
      console.warn('no id provided to replaceElementContentById, so adding direct to DOM');
      this.app.browser.addElementToDom(html);
    } else {
      let obj = document.getElementById(id);
      if (obj) {
        obj.innerHTML = html;
      }
    }
  }

  replaceElementById(html, id = null) {
    if (id == null) {
      console.warn('no id provided to replaceElementById, so adding direct to DOM');
      this.app.browser.addElementToDom(html);
    } else {
      let obj = document.getElementById(id);
      if (obj) {
        obj.outerHTML = html;
      }
    }
  }

  replaceElementByIdOrAddToDom(html, id = null) {
    if (id == null) {
      console.warn('no id provided to replaceElementById, so ignoring');
    } else {
      let obj = document.getElementById(id);
      if (obj) {
        obj.outerHTML = html;
      } else {
        this.app.browser.addElementToDom(html);
      }
    }
  }

  addElementToId(html, id = null) {
    if (id == null) {
      console.warn(`no id provided to addElementToId, so adding to DOM`);
      this.app.browser.addElementToDom(html);
    } else {
      let obj = document.getElementById(id);
      if (obj) {
        this.app.browser.addElementToDom(html, obj);
      } else {
        console.error('[addElementToId] id not found');
      }
    }
  }

  addElementAfterId(html, id = null) {
    if (id) {
      let obj = document.getElementById(id);
      if (obj) {
        this.app.browser.addElementToDom(html, obj);
        const el = document.createElement('div');
        el.outerHTML = html;
        obj.insertAdjacentElement('afterend', el);
        return;
      }
    }
    console.warn(`no id provided/found to addElementAfterId, so adding to DOM`);
    this.app.browser.addElementToDom(html);
  }

  prependElementToId(html, id = null) {
    if (id == null) {
      console.warn(`no id provided to prependElementToId, so adding to DOM`);
      this.app.browser.prependElementToDom(html);
    } else {
      let obj = document.getElementById(id);
      if (obj) {
        this.app.browser.prependElementToDom(html, obj);
      }
    }
  }

  removeElementBySelector(selector = '') {
    if (selector === '') {
      console.warn('no selector provided to removeElementBySelector');
      return;
    }
    let obj = document.querySelector(selector);
    if (obj) {
      obj.remove();
    }
  }

  replaceElementBySelector(html, selector = '') {
    if (selector === '') {
      console.warn('no selector provided to replaceElementBySelector, so adding direct to DOM');
      this.app.browser.addElementToDom(html);
    } else {
      let obj = document.querySelector(selector);
      if (obj) {
        obj.outerHTML = html;
      }
    }
  }

  replaceElementContentBySelector(html, selector = '') {
    if (selector === '') {
      console.warn(
        'no selector provided to replaceElementContentBySelector, so adding direct to DOM'
      );
      this.app.browser.addElementToDom(html);
    } else {
      let obj = document.querySelector(selector);
      if (obj) {
        obj.innerHTML = html;
      }
    }
  }

  addElementToSelectorOrDom(html, selector = '') {
    if (selector === '') {
      console.warn('no selector provided to addElementToSelectorOrDom, so adding direct to DOM');
      this.app.browser.addElementToDom(html);
    } else {
      let container = document.querySelector(selector);
      if (container) {
        this.app.browser.addElementToElement(html, container);
      } else {
        console.info(`${selector} not found, adding direct to DOM`);
        this.app.browser.addElementToDom(html);
      }
    }
  }

  addElementToSelector(html, selector = '') {
    if (selector === '') {
      console.warn('no selector provided to addElementToSelector, so adding direct to DOM');
      console.debug(html);
      this.app.browser.addElementToDom(html);
    } else {
      let container = document.querySelector(selector);
      if (container) {
        this.app.browser.addElementToElement(html, container);
      } else {
        console.error('Container not found: ' + selector);
      }
    }
  }

  addElementAfterSelector(html, selector = '') {
    if (selector) {
      let container = document.querySelector(selector);
      if (container) {
        const el = document.createElement('div');
        container.insertAdjacentElement('afterend', el);
        el.outerHTML = html;
        return;
      }
    }

    console.warn('no selector provided/found to addElementAfterSelector, so adding direct to DOM');
    console.debug(html, selector);
    this.app.browser.addElementToDom(html);
  }

  prependElementToSelector(html, selector = '') {
    if (selector === '') {
      console.warn('no selector provided to prependElementToSelector, so adding direct to DOM');
      this.app.browser.prependElementToDom(html);
    } else {
      let container = document.querySelector(selector);
      if (container) {
        this.app.browser.prependElementToDom(html, container);
      }
    }
  }

  replaceElementByClass(html, classname = '') {
    if (classname === '') {
      console.warn('no classname provided to replaceElementByClass, so adding direct to DOM');
      this.app.browser.addElementToDom(html);
    } else {
      let classname = '.' + classname;
      let obj = document.querySelector(classname);
      if (obj) {
        obj.outerHTML = html;
      }
    }
  }

  addElementToClass(html, classname = '') {
    if (classname === '') {
      console.warn('no classname provided to addElementToClass, so adding direct to DOM');
      this.app.browser.addElementToDom(html);
    } else {
      classname = '.' + classname;
      let container = document.querySelector(classname);
      if (container) {
        this.app.browser.addElementToElement(html, container);
      } else {
        console.error('Classname not found: ' + classname);
      }
    }
  }

  prependElementToClass(html, classname = '') {
    if (classname === '') {
      console.warn('no classname provided to prependElementToClass, so adding direct to DOM');
      this.app.browser.prependElementToDom(html);
    } else {
      classname = '.' + classname;
      let container = document.querySelector(classname);
      if (container) {
        this.app.browser.prependElementToDom(html, container);
      }
    }
  }

  addElementToElement(html, elem = document.body) {
    try {
      const el = document.createElement('div');
      elem.appendChild(el);
      el.outerHTML = html;
    } catch (err) {
      console.error('ERROR 582342: error in addElementToElement. Does ' + elem + ' exist?');
      console.debug(elem, html);
    }
  }

  addElementAfterElement(html, elem = document.body) {
    try {
      const el = document.createElement('div');
      if (elem.nextSibling) {
        elem.parentNode.insertBefore(el, elem.nextSibling);
      } else {
        elem.parentNode.appendChild(el);
      }
      el.outerHTML = html;
    } catch (err) {
      console.error(
        'ERROR 582346: error in addElementToElement. Does ' + elem + ' exist? : ' + err
      );
      console.debug(elem, html);
    }
  }

  makeElement(elemType, elemId, elemClass) {
    const headerDiv = document.createElement(elemType);
    headerDiv.id = elemId;
    headerDiv.classList.add(elemClass);
    return headerDiv;
  }

  htmlToElement(domstring) {
    const html = new DOMParser().parseFromString(domstring, 'text/html');
    return html.body.firstChild;
  }

  addToolTip(elem, text) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('tip');
    elem.replaceWith(wrapper);
    const tip = document.createElement('div');
    tip.classList.add('tiptext');
    tip.innerHTML = text;
    wrapper.append(elem);
    wrapper.append(tip);
  }

  formatTime(milliseconds = 0) {
    let hours = parseInt(milliseconds / 3600000);
    milliseconds = milliseconds % 3600000;

    let minutes = parseInt(milliseconds / 60000);
    milliseconds = milliseconds % 60000;

    let seconds = parseInt(milliseconds / 1000);

    return { hours: hours, minutes: minutes, seconds: seconds };
  }

  returnTime(timestamp) {
    let d = this.formatDate(timestamp);
    let h = d.hours;
    let m = d.minutes;
    let x = '';
    if (h < 10) {
      x = `0${h}`;
    } else {
      x = `${h}`;
    }
    x += `:${m}`;

    return x;
  }

  formatDate(timestamp) {
    const datetime = new Date(timestamp);
    const hours = datetime.getHours();
    let minutes = datetime.getMinutes();
    const months = [12];
    months[0] = 'January';
    months[1] = 'February';
    months[2] = 'March';
    months[3] = 'April';
    months[4] = 'May';
    months[5] = 'June';
    months[6] = 'July';
    months[7] = 'August';
    months[8] = 'September';
    months[9] = 'October';
    months[10] = 'November';
    months[11] = 'December';
    const month = months[datetime.getMonth()];
    const day = datetime.getDate();
    const year = datetime.getFullYear();
    minutes = minutes.toString().length == 1 ? `0${minutes}` : `${minutes}`;
    return { year, month, day, hours, minutes };
  }

  prettifyTimeStamp(timestamp, short_month = false) {
    let object = this.formatDate(timestamp);

    let timeString = short_month ? object.month.substr(0, 3) : object.month;
    timeString += ` ${object.day}, ${object.hours}:${object.minutes}`;
    return timeString;
  }

  saneDateFromTimestamp(timestamp, with_year = true) {
    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = date.getMonth() + 1; // getMonth() returns month from 0-11
    var day = date.getDate();

    // Adding leading zeros for day and month if they are less than 10
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;

    let return_str = month + '-' + day;
    if (with_year) {
      return year + '-' + return_str;
    } else {
      return return_str;
    }
  }

  formatTimeDifference(timestamp) {
    const now = Math.floor(Date.now() / 1000); // Convert current time to seconds
    const diff = now - timestamp;

    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    return `${Math.floor(diff / 86400)} days ago`;
  }

  formatRelativeTime(timestamp = 0) {
    const diffMs = Math.max(0, Date.now() - Number(timestamp));
    const diffMinutes = Math.floor(diffMs / 60000);

    if (diffMinutes < 60) {
      return `${Math.max(1, diffMinutes)}m`;
    }

    const diffHours = Math.floor(diffMinutes / 60);

    if (diffHours < 24) {
      return `${diffHours}h`;
    }

    const diffDays = Math.floor(diffHours / 24);

    return `${diffDays}d`;
  }

  saneTimeFromTimestamp(timestamp, with_seconds = true) {
    var date = new Date(timestamp);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();

    // Adding leading zeros for hours, minutes, and seconds if they are less than 10
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    let return_str = hours + ':' + minutes;
    if (with_seconds) {
      return_str += ':' + seconds;
    }
    return return_str;
  }

  saneDateTimeFromTimestamp(timestamp, detailed = true) {
    return (
      this.saneDateFromTimestamp(timestamp, detailed) +
      '/' +
      this.saneTimeFromTimestamp(timestamp, detailed)
    );
  }

  formatNumberWithCommas(number) {
    // Split the number into integer and decimal parts
    var parts = number.toString().split('.');

    // Format the integer part with commas
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Return the combined formatted number
    return parts.join('.');
  }

  showFileReadSpinner(dropArea: HTMLElement) {
    // Check if spinner already exists
    if (dropArea.querySelector('.saito-file-read-spinner')) {
      return; // Already showing
    }

    // Ensure position relative for absolute positioning of spinner
    const computedStyle = window.getComputedStyle(dropArea);
    if (computedStyle.position === 'static') {
      dropArea.style.position = 'relative';
      // Store original position to restore later
      if (!dropArea.dataset.originalPosition) {
        dropArea.dataset.originalPosition = dropArea.style.position || '';
      }
    }

    const spinnerHtml = `
      <div class="saito-file-read-spinner" style="
        position: absolute; top: 0; left: 0; right: 0; bottom: 0;
        display: flex; flex-direction: column; align-items: center; justify-content: center;
        background: rgba(0, 0, 0, 0.7); z-index: 1000; border-radius: inherit;
      ">
        <div class="saito-spinner" style="width: 4rem; height: 4rem;"></div>
        <div style="color: white; margin-top: 1rem; font-size: 1.4rem;">Reading file...</div>
      </div>
    `;
    dropArea.insertAdjacentHTML('beforeend', spinnerHtml);
  }

  hideFileReadSpinner(dropArea: HTMLElement) {
    const spinner = dropArea.querySelector('.saito-file-read-spinner');
    if (spinner) {
      spinner.remove();
    }

    // Restore original position if we changed it
    if (dropArea.dataset.originalPosition !== undefined) {
      const originalPos = dropArea.dataset.originalPosition;
      if (originalPos === '') {
        dropArea.style.position = '';
      } else {
        dropArea.style.position = originalPos;
      }
      delete dropArea.dataset.originalPosition;
    }
  }

  addDragAndDropFileUploadToElement(
    id,
    handleFileDrop = null,
    click_to_upload = true,
    read_as_array_buffer = false,
    read_as_text = false
  ) {
    const hidden_upload_form = `
      <form id="uploader_${id}" class="saito-file-uploader" style="display:none">
        <p>Upload multiple files with the file dialog or by dragging and dropping images onto the dashed region</p>
        <input type="file" id="hidden_file_element_${id}" multiple accept="*" class="treated hidden_file_element_${id}">
        <label class="hidden_file_element_button" id="hidden_file_element_button_${id}" for="hidden_file_element_${id}">Select some files</label>
      </form>
    `;

    if (!document.getElementById(`uploader_${id}`)) {
      this.addElementToId(hidden_upload_form, id);
      const dropArea = document.getElementById(id);
      if (!dropArea) {
        console.error('Undefined id in browser', id);
        return null;
      }
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
        dropArea.addEventListener(eventName, this.preventDefaults, false);
      });
      ['dragenter', 'dragover'].forEach((eventName) => {
        dropArea.addEventListener(eventName, this.highlight, false);
      });
      ['dragleave', 'drop'].forEach((eventName) => {
        dropArea.addEventListener(eventName, this.unhighlight, false);
      });
      dropArea.addEventListener(
        'drop',
        (e) => {
          const dt = e.dataTransfer;
          const files = dt.files;
          const self = this; // Capture Browser instance
          [...files].forEach(function (file) {
            // Early size validation - check BEFORE reading
            // This prevents memory issues with very large files when using readAsDataURL
            if (!read_as_array_buffer && !read_as_text && file.size > self.MAX_FILE_SIZE) {
              console.warn(
                `File ${file.name} (${file.size} bytes) exceeds safe size limit for readAsDataURL`
              );
              // Call handler with null file to indicate failure
              if (handleFileDrop) {
                handleFileDrop(null, false, file);
              }
              return;
            }

            // Show spinner before reading
            self.showFileReadSpinner(dropArea);

            const reader = new FileReader();

            // Helper to hide spinner and call handler
            const cleanupAndCall = (result, file) => {
              self.hideFileReadSpinner(dropArea);
              if (handleFileDrop) {
                handleFileDrop(result, false, file);
              }
            };

            // Add error handler (backwards compatible - calls handler with null file)
            reader.addEventListener('error', (event) => {
              console.error('FileReader error for file:', file.name, file.size, 'bytes');
              cleanupAndCall(null, file);
            });

            // Add abort handler
            reader.addEventListener('abort', (event) => {
              console.warn('FileReader aborted for file:', file.name);
              cleanupAndCall(null, file);
            });

            reader.addEventListener('load', (event) => {
              cleanupAndCall(event.target.result, file);
            });
            if (read_as_array_buffer) {
              reader.readAsArrayBuffer(file);
            } else if (read_as_text) {
              reader.readAsText(file);
            } else {
              reader.readAsDataURL(file);
            }
          });
        },
        false
      );
      if (!dropArea.classList.contains('paste_event')) {
        dropArea.addEventListener(
          'paste',
          (e) => {
            let drag_and_drop = false;
            const files = e.clipboardData.files;
            const self = this; // Capture Browser instance
            [...files].forEach(function (file) {
              drag_and_drop = true;

              // Early size validation - check BEFORE reading
              const MAX_SAFE_SIZE = 100 * 1024 * 1024; // 100MB safety limit
              if (!read_as_array_buffer && !read_as_text && file.size > MAX_SAFE_SIZE) {
                console.warn(
                  `File ${file.name} (${file.size} bytes) exceeds safe size limit for readAsDataURL`
                );
                if (handleFileDrop) {
                  handleFileDrop(null, true, file);
                }
                return;
              }

              // Show spinner before reading
              self.showFileReadSpinner(dropArea);

              const reader = new FileReader();

              // Helper to hide spinner and call handler
              const cleanupAndCall = (result, file) => {
                self.hideFileReadSpinner(dropArea);
                if (handleFileDrop) {
                  handleFileDrop(result, true, file);
                }
              };

              // Add error handler
              reader.addEventListener('error', (event) => {
                console.error('FileReader error for file:', file.name, file.size, 'bytes');
                cleanupAndCall(null, file);
              });

              // Add abort handler
              reader.addEventListener('abort', (event) => {
                console.warn('FileReader aborted for file:', file.name);
                cleanupAndCall(null, file);
              });

              reader.addEventListener('load', (event) => {
                cleanupAndCall(event.target.result, file);
              });
              if (read_as_array_buffer) {
                reader.readAsArrayBuffer(file);
              } else {
                if (read_as_text) {
                  reader.readAsText(file);
                } else {
                  reader.readAsDataURL(file);
                }
              }
            });

            if (drag_and_drop) {
              this.preventDefaults(e);
            }
          },
          false
        );

        dropArea.classList.add('paste_event');
      }
      const input = document.getElementById(`hidden_file_element_${id}`);
      if (click_to_upload == true) {
        dropArea.addEventListener('click', function (e) {
          input.click();
        });
      }

      input.addEventListener(
        'change',
        (e) => {
          const fileName = '';
          if (input.files && input.files.length > 0) {
            const files = input.files;
            const self = this; // Capture Browser instance
            [...files].forEach(function (file) {
              // Early size validation - check BEFORE reading
              const MAX_SAFE_SIZE = 100 * 1024 * 1024; // 100MB safety limit
              if (!read_as_array_buffer && !read_as_text && file.size > MAX_SAFE_SIZE) {
                console.warn(
                  `File ${file.name} (${file.size} bytes) exceeds safe size limit for readAsDataURL`
                );
                if (handleFileDrop) {
                  handleFileDrop(null, false, file);
                }
                return;
              }

              // Show spinner before reading
              self.showFileReadSpinner(dropArea);

              const reader = new FileReader();

              // Helper to hide spinner and call handler
              const cleanupAndCall = (result, file) => {
                self.hideFileReadSpinner(dropArea);
                if (handleFileDrop) {
                  handleFileDrop(result, false, file);
                }
              };

              // Add error handler
              reader.addEventListener('error', (event) => {
                console.error('FileReader error for file:', file.name, file.size, 'bytes');
                cleanupAndCall(null, file);
              });

              // Add abort handler
              reader.addEventListener('abort', (event) => {
                console.warn('FileReader aborted for file:', file.name);
                cleanupAndCall(null, file);
              });

              reader.addEventListener('load', (event) => {
                cleanupAndCall(event.target.result, file);
              });
              if (read_as_array_buffer) {
                reader.readAsArrayBuffer(file);
              } else {
                if (read_as_text) {
                  reader.readAsText(file);
                } else {
                  reader.readAsDataURL(file);
                }
              }
            });
          }
        },
        false
      );
      dropArea.focus();
    }
  }

  highlight(e) {
    document.getElementById(e.currentTarget.id).style.opacity = 0.8;
  }

  unhighlight(e) {
    document.getElementById(e.currentTarget.id).style.opacity = 1;
  }

  preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  makeRefreshable(selector, mycallback = null) {
    let touchStartY = 0;
    let triggerRefresh = false;

    let element = document.querySelector(selector);

    if (!element) {
      console.error("Browser [makeRefreshable]: Element doesn't exist!");
      return;
    }

    if (!mycallback) {
      console.error('Browser [makeRefreshable]: no callback!');
      return;
    }

    element.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
      triggerRefresh = false;
    });

    element.addEventListener('touchmove', (e) => {
      const touchY = e.touches[0].clientY;
      const touchDiff = touchY - touchStartY;
      if (touchDiff > 100 && window.scrollY === 0) {
        triggerRefresh = true;
      }
    });

    element.addEventListener('touchend', (e) => {
      if (triggerRefresh) {
        mycallback();
      }
    });
  }

  makeDraggable(id_to_move, id_to_drag = '', dockable = false, mycallback = null) {
    //console.debug("make draggable: " + id_to_drag);
    //console.debug(" and move? " + id_to_move);

    try {
      const element_to_move = document.getElementById(id_to_move);
      let timeout = null;
      let element_to_drag = element_to_move;
      if (id_to_drag) {
        element_to_drag = document.getElementById(id_to_drag);
      }

      let element_moved = 0;

      let mouse_down_left = 0;
      let mouse_down_top = 0;
      let mouse_current_left = 0;
      let mouse_current_top = 0;
      let element_start_left = 0;
      let element_start_top = 0;

      element_to_drag.onmousedown = function (e) {
        if (timeout) {
          clearTimeout(timeout);
        }
        let resizeable = ['both', 'vertical', 'horizontal'];
        //nope out if the elemtn or it's parent are css resizable - and the click is within 20px of the bottom right corner.

        if (
          resizeable.indexOf(getComputedStyle(e.target).resize) > -1 ||
          resizeable.indexOf(getComputedStyle(e.target.parentElement).resize) > -1
        ) {
          if (e.offsetX > e.target.offsetWidth - 20 && e.offsetY > e.target.offsetHeight - 20) {
            return;
          }
        }

        e = e || window.event;

        if (
          !e.currentTarget.id ||
          (e.currentTarget.id != id_to_move && e.currentTarget.id != id_to_drag)
        ) {
          document.onmouseup = null;
          document.onmousemove = null;
          return;
        }

        element_to_move.style.transition = 'unset';

        const rect = element_to_move.getBoundingClientRect();
        element_start_left = rect.left;
        element_start_top = rect.top;

        mouse_down_left = e.clientX;
        mouse_down_top = e.clientY;

        element_moved = false;

        document.onmouseup = async function (e) {
          if (dockable) {
            if (element_to_move.classList.contains('dockedLeft')) {
              element_to_move.style.left = 0;
            }

            if (element_to_move.classList.contains('dockedTop')) {
              element_to_move.style.top = 0;
            }

            if (element_to_move.classList.contains('dockedRight')) {
              element_to_move.style.left =
                window.innerWidth - element_to_move.getBoundingClientRect().width + 'px';
            }

            if (element_to_move.classList.contains('dockedBottom')) {
              element_to_move.style.top =
                window.innerHeight - element_to_move.getBoundingClientRect().height + 'px';
            }

            if (element_to_move.classList.contains('dragging')) {
              element_to_move.classList.remove('dragging');
            }

            timeout = setTimeout(() => {
              element_to_move.classList.remove('dockedBottom');
              element_to_move.classList.remove('dockedTop');
              element_to_move.classList.remove('dockedRight');
              element_to_move.classList.remove('dockedLeft');
            }, 1200);
          }

          document.onmouseup = null;
          document.onmousemove = null;

          element_to_move.style.transition = '';
          if (mycallback && element_moved) {
            await mycallback();
          }
        };

        document.onmousemove = function (e) {
          e = e || window.event;
          e.preventDefault();
          const threshold = 25;

          mouse_current_left = e.clientX;
          mouse_current_top = e.clientY;
          const adjustmentX = mouse_current_left - mouse_down_left;
          const adjustmentY = mouse_current_top - mouse_down_top;

          if (adjustmentX !== 0 || adjustmentY !== 0) {
            element_moved = true;
          }

          element_to_move.classList.add('dragging');

          let newPosX = element_start_left + adjustmentX;
          let newPosY = element_start_top + adjustmentY;

          //if dockable show docking edge
          if (dockable) {
            if (Math.abs(element_to_move.getBoundingClientRect().x) < threshold) {
              element_to_move.classList.add('dockedLeft');
            } else {
              element_to_move.classList.remove('dockedLeft');
            }

            if (Math.abs(element_to_move.getBoundingClientRect().y < threshold)) {
              element_to_move.classList.add('dockedTop');
            } else {
              element_to_move.classList.remove('dockedTop');
            }

            if (
              Math.abs(
                element_to_move.getBoundingClientRect().x +
                  element_to_move.getBoundingClientRect().width -
                  window.innerWidth
              ) < threshold
            ) {
              element_to_move.classList.add('dockedRight');
            } else {
              element_to_move.classList.remove('dockedRight');
            }

            if (
              Math.abs(
                element_to_move.getBoundingClientRect().y +
                  element_to_move.getBoundingClientRect().height -
                  window.innerHeight
              ) < threshold
            ) {
              element_to_move.classList.add('dockedBottom');
            } else {
              element_to_move.classList.remove('dockedBottom');
            }

            // set the element's new position:

            if (Math.abs(newPosX) < threshold) {
              newPosX = 0;
            }
            if (
              Math.abs(
                newPosX + element_to_move.getBoundingClientRect().width - window.innerWidth
              ) < threshold
            ) {
              newPosX = window.innerWidth - element_to_move.getBoundingClientRect().width;
            }

            if (Math.abs(newPosY) < threshold) {
              newPosY = 0;
            }
            if (
              Math.abs(
                newPosY + element_to_move.getBoundingClientRect().height - window.innerHeight
              ) < threshold
            ) {
              newPosY = window.innerHeight - element_to_move.getBoundingClientRect().height;
            }
          }

          element_to_move.style.left = newPosX + 'px';
          element_to_move.style.top = newPosY + 'px';

          //We are changing to Top/Left so get rid of bottom/right
          element_to_move.style.bottom = 'unset';
          element_to_move.style.right = 'unset';
          //Styles that adjust where the element goes, need to go away!
          element_to_move.style.transform = 'unset';
          element_to_move.style.marginTop = 'unset';
          element_to_move.style.marginLeft = 'unset';
        };

        return false;
      };

      element_to_drag.ontouchstart = function (e) {
        e = e || window.event;

        if (
          !e.currentTarget.id ||
          (e.currentTarget.id != id_to_move && e.currentTarget.id != id_to_drag)
        ) {
          document.ontouchend = null;
          document.ontouchmove = null;
          return;
        }

        element_to_move.style.transition = 'unset';

        const rect = element_to_move.getBoundingClientRect();
        element_start_left = rect.left;
        element_start_top = rect.top;
        mouse_down_left = e.targetTouches[0]
          ? e.targetTouches[0].pageX
          : e.changedTouches[e.changedTouches.length - 1].pageX;
        mouse_down_top = e.targetTouches[0]
          ? event.targetTouches[0].pageY
          : e.changedTouches[e.changedTouches.length - 1].pageY;
        mouse_current_left = mouse_down_left;
        mouse_current_top = mouse_down_top;

        document.ontouchend = async function (e) {
          document.ontouchend = null;
          document.ontouchmove = null;
          if (mycallback && element_moved) {
            await mycallback();
          }
        };

        document.ontouchmove = function (e) {
          e = e || window.event;
          //e.preventDefault();

          mouse_current_left = e.targetTouches[0]
            ? e.targetTouches[0].pageX
            : e.changedTouches[e.changedTouches.length - 1].pageX;
          mouse_current_top = e.targetTouches[0]
            ? event.targetTouches[0].pageY
            : e.changedTouches[e.changedTouches.length - 1].pageY;
          const adjustmentX = mouse_current_left - mouse_down_left;
          const adjustmentY = mouse_current_top - mouse_down_top;

          if (adjustmentX !== 0 || adjustmentY !== 0) {
            element_moved = true;
          }

          element_to_move.classList.add('dragging');

          // set the element's new position:
          element_to_move.style.left = element_start_left + adjustmentX + 'px';
          element_to_move.style.top = element_start_top + adjustmentY + 'px';
          element_to_move.style.bottom = 'unset';
          element_to_move.style.right = 'unset';
          element_to_move.style.transform = 'unset';
          element_to_move.style.marginTop = 'unset';
          element_to_move.style.marginLeft = 'unset';
        };
      };
    } catch (err) {
      console.error('Browser [makeDraggable] error: ' + err);
    }
  }

  cancelDraggable(id_to_drag) {
    try {
      let element_to_drag = document.getElementById(id_to_drag);
      element_to_drag.onmousedown = null;
      element_to_drag.ontouchstart = null;
    } catch (err) {
      console.error('Browser [cancelDraggable] error: ' + err);
    }
  }

  /**
   * Callback is called on mousedown
   */
  makeResizeable(
    target_div,
    icon_div = null,
    unique_id = null,
    direction = 'diagonal',
    callback = null
  ) {
    let d = document;
    let target = d.querySelector(target_div);
    let pullTab = null;

    this.addElementToSelector(
      `<div class="resize-icon ${direction}" id="resize-icon-${unique_id}"></div>`,
      icon_div
    );
    pullTab = d.getElementById(`resize-icon-${unique_id}`);

    let ht, wd, x, y, dx, dy;

    const prepareToResize = () => {
      let dimensions = target.getBoundingClientRect();
      ht = dimensions.height;
      wd = dimensions.width;

      //
      // Draggable elements may have top/left set, but we want the bottom/right to be fixed
      //
      target.style.top = '';
      target.style.left = '';
      target.style.bottom = window.innerHeight - dimensions.bottom + 'px';
      target.style.right = window.innerWidth - dimensions.right + 'px';
    };

    pullTab.onmousedown = (evt) => {
      x = evt.screenX;
      y = evt.screenY;

      evt.stopImmediatePropagation();
      evt.preventDefault();

      prepareToResize();

      //Get rid of any animation delays
      target.style.transition = 'unset';

      d.body.onmousemove = (evt) => {
        dx = evt.screenX - x;
        dy = evt.screenY - y;
        x = evt.screenX;
        y = evt.screenY;

        if (direction == 'horizontal') {
          wd += dx;
          target.style.width = wd + 'px';
        }
        if (direction == 'vertical') {
          ht += dy;
          target.style.height = ht + 'px';
        }

        if (direction == 'diagonal') {
          wd -= dx;
          ht -= dy;
          target.style.width = wd + 'px';
          target.style.height = ht + 'px';
        }
      };

      d.body.onmouseup = () => {
        d.body.onmousemove = null;
        target.style.transition = '';
      };

      if (callback) {
        callback();
      }
    };
  }

  returnAddressHTML(key, disable = false) {
    return `<div class="saito-address" data-id="${this.escapeHTML(key)}" ${disable ? `data-disable="true"` : ''}>${this.escapeHTML(this.app.keychain.returnUsername(key))}</div>`;
  }

  updateAddressHTML(key, id) {
    if (!id || key === id) {
      return;
    }

    try {
      Array.from(document.querySelectorAll(`.saito-address.treated[data-id='${key}']`)).forEach(
        (add) => (add.innerText = id)
      );
    } catch (err) {
      console.error('Browser [updateAddressHTML] error: ', err);
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  /////////////////////// url-hash helper functions ////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  // TODO: Add a function which alphabetizes keys so that noop url changes will
  // always act correctly... .e.g. someFunction("#bar=1&foo=2") should never
  // return "#foo=1&bar=2". Some other way of preserving order may be better...
  //////////////////////////////////////////////////////////////////////////////
  //
  // Parse a url-hash string into an object.
  // usage: parseHash("#foo=1&bar=2") --> {foo: 1, bar: 2}
  parseHash(hash) {
    if (hash === '') {
      return {};
    }
    return hash
      .substr(1)
      .split('&')
      .reduce(function (result, item) {
        const parts = item.split('=');
        result[parts[0]] = parts[1];
        return result;
      }, {});
  }

  // Build a url-hash string from an object.
  // usage: buildHash({foo: 1, bar: 2}) --> "#foo=1&bar=2"
  buildHash(hashObj) {
    const hashString = Object.keys(hashObj).reduce((output, key) => {
      const val = hashObj[key];
      return output + `&${key}=${hashObj[key]}`;
    }, '');
    return '#' + hashString.substr(1);
  }

  // Remove a subset of key-value pairs from a url-hash string.
  // usage: removeFromHash("#foo=1&bar=2","bar") --> "#foo=1"
  removeFromHash(hash, ...keys) {
    const hashObj = this.parseHash(hash);
    keys.forEach((key, i) => {
      delete hashObj[key];
    });
    return this.buildHash(hashObj);
  }

  // Add new key-value pairs to the hash.
  // usage: modifyHash("#foo=1",{bar: 2}) --> "#foo=1&bar=2"
  modifyHash(oldHash, newHashValues) {
    return this.buildHash(Object.assign(this.parseHash(oldHash), newHashValues));
  }

  // Override defaults with other values. Useful to initialize a page.
  // usage: modifyHash("#foo=1&bar=2","#foo=3") --> "#foo=3&bar=2"
  defaultHashTo(defaultHash, newHash) {
    return this.buildHash(Object.assign(this.parseHash(defaultHash), this.parseHash(newHash)));
  }

  // Initialize a hash on page load.
  // Typically some values need a setting but can be overridden by a "deep link".
  // Other values must take certain values on page load, e.g. ready=false these
  // go in the forcedHashValues
  //
  // usage:
  // let currentHash = window.location.hash; // (e.g."#page=2&ready=1")
  initializeHash(defaultHash, deepLinkHash, forcedHashValues) {
    return this.modifyHash(this.defaultHashTo(defaultHash, deepLinkHash), forcedHashValues);
  }

  //////////////////////////////////////////////////////////////////////////////
  /////////////////////// end url-hash helper functions ////////////////////////
  //////////////////////////////////////////////////////////////////////////////

  async screenshotCanvasElementById(id = '', callback = null) {
    let canvas = document.getElementById(id);
    if (canvas) {
      let img = canvas.toDataURL('image/jpeg', 0.35);
      if (callback != null) {
        callback(img);
        d;
      }
    }
  }

  extractFirstValidURL(text) {
    let first_link = null;
    let links = text.match(this.urlRegexp());

    while (links?.length > 0) {
      first_link = links.pop();

      if (!this.numberFilter(first_link)) {
        break;
      } else {
        first_link = null;
      }
    }

    if (first_link) {
      if (!first_link.startsWith('http')) {
        first_link = 'http://' + first_link;
      }

      let urlParams = null;

      try {
        let link = new URL(first_link);
        urlParams = new URLSearchParams(link.search);

        return link.toString();
      } catch (err) {
        console.error(first_link + ' is not a valid url');
        return;
      }
    }
    return null;
  }

  //
  // neither of these is quite right and the internet is full of wrong answers
  //
  urlRegexp() {
    // from tweet.js
    // let expression = /\b(?:https?:\/\/)?[\w.]{2,}\.[a-zA-Z]{1,}(\/[\w\/.-]*)?(\?[^<\s]*)?(?![^<]*>)/gi;

    // from sanitize let urlPattern = /\b(?:https?:\/\/)?[\w]+(\.[\w]+)+\.[a-zA-Z]{2,}(\/[\w\/.-]*)?(\?[^<\s]*)?(?![^<]*>)/gi;
    // The sanitizeHtml converts & into `&amp;` so we should match on ;
    // let daniels_regex = /(?<!>)\b(?:https?:\/\/|www\.|https?:\/\/www\.)?(?:\w{2,}\.)+\w{2,}(?:\/[a-zA-Z0-9_\?=#&;@\-\.]*)*\b(?!<\/)/gi;
    // this pointlessly looks for www, but does not identify the majority of valid urls or any url without http/https in front of it.

    // Re-added this code as urls don't work without it. Did chance the var names for safety.

    //this should identify patterns like x.com and staging.saito.io which the others do not.
    let urlIndentifierRegexp =
      /\b(?:https?:\/\/)?([\w-]+[\.:])+[\w-]{2,}(\/[\w\/.-]*)?(\?[^<\s]*)?(?![^<]*>)/gi;
    return urlIndentifierRegexp;
  }

  numberFilter(potential_link) {
    let regex = /^\d+[\.:]?\d*$/;
    return regex.test(potential_link);
  }

  /**
   * Return a compact label for a URL without changing the URL used by the link.
   */
  formatUrlForDisplay(url, maxLength = 42) {
    let displayUrl = String(url ?? '').trim();
    if (!displayUrl) {
      return '';
    }

    displayUrl = displayUrl.replace(/^https?:\/\//i, '').replace(/^www\./i, '');

    const limit = Math.max(4, Number(maxLength) || 42);
    if (displayUrl.length > limit) {
      displayUrl = displayUrl.slice(0, limit - 3) + '...';
    }

    return displayUrl;
  }

  /**
   * Sanitize untrusted metadata that may contain basic inline emphasis.
   * This deliberately excludes links, images, block elements and all attributes.
   */
  sanitizeInlineHtml(text) {
    if (!text) {
      return '';
    }

    return sanitizeHtml(String(text), {
      allowedTags: ['em', 'i', 'strong', 'b'],
      allowedAttributes: {}
    });
  }

  /**
   * Repair anchors produced by an older publisher that used a smart quote to
   * close href attributes. Keep this deliberately narrow: only a lone href is
   * accepted, and its value must pass the same URL policy as normal links.
   */
  normalizeLegacySmartQuotedAnchors(text) {
    return String(text ?? '').replace(
      /<a\s+href=(["'])([^<>"']+)[‘’“”]\s*>/gi,
      (match, _openingQuote, href) => {
        const decodedHref = sanitizer.unescapeEntities(String(href).trim());
        if (!this.isSafeHref(decodedHref)) {
          return match;
        }
        return `<a href="${this.escapeHTML(decodedHref)}">`;
      }
    );
  }

  sanitize(text, createLinks = false) {
    if (!text) {
      return '';
    }
    try {
      text = this.normalizeLegacySmartQuotedAnchors(text);

      if (createLinks) {
        const host =
          typeof window !== 'undefined' && window.location && window.location.host
            ? window.location.host
            : '';

        const renderer = new marked.Renderer();
        const defaultLinkRenderer = renderer.link.bind(renderer);
        renderer.link = (href, title, linkText) => {
          const decodedHref = sanitizer.unescapeEntities(String(href ?? ''));
          const decodedText = sanitizer.unescapeEntities(String(linkText ?? ''));
          const hrefFromLabel = this.hrefFromAutolink(decodedText);

          // Marked has already converted bare URLs into anchors. Shorten only
          // their generated labels, preserving authored Markdown link text.
          if (
            (decodedText === decodedHref || hrefFromLabel === decodedHref) &&
            this.isSafeHref(decodedHref) &&
            decodedText.length > 42
          ) {
            linkText = this.escapeHTML(this.formatUrlForDisplay(decodedText));
          }

          return defaultLinkRenderer(href, title, linkText);
        };

        text = marked.parse(text, { renderer });

        text = text.replace(this.urlRegexp(), (...args) => {
          const url = args[0];
          const offset = args[args.length - 2];
          const full = args[args.length - 1];
          const before = full.slice(0, offset);
          const openAnchors = (before.match(/<a\b/gi) || []).length;
          const closeAnchors = (before.match(/<\/a>/gi) || []).length;
          if (openAnchors > closeAnchors) {
            return url;
          }

          if (this.numberFilter(url)) {
            return url;
          }

          const hrefRaw = this.hrefFromAutolink(url);
          if (!hrefRaw || !this.isSafeHref(hrefRaw)) {
            return url;
          }

          const url2 = this.formatUrlForDisplay(url);

          const extra =
            host && hrefRaw.includes(host)
              ? "data-link='local_link' "
              : "target='_blank' rel='noopener noreferrer' ";

          return `<a ${extra} class="saito-link" href="${this.escapeHTML(hrefRaw)}">${this.escapeHTML(url2)}</a>`;
        });
      }

      text = String(text).replace(/\sid=(["']).*?\1/gi, '');

      text = sanitizeHtml(text, {
        allowedTags: [
          'a',
          'p',
          'br',
          'div',
          'span',
          'ul',
          'ol',
          'li',
          'blockquote',
          'strong',
          'b',
          'em',
          'i',
          'strike',
          'del',
          'code',
          'pre',
          'hr',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          'table',
          'thead',
          'tbody',
          'tr',
          'th',
          'td',
          'img'
        ],
        allowedAttributes: {
          a: ['href', 'class', 'target', 'rel', 'data-link'],
          span: ['class', 'data-id'],
          div: ['class', 'id'],
          img: ['src', 'class', 'alt'],
          blockquote: ['href'],
          code: ['class']
        },
        selfClosing: ['img', 'br', 'hr'],
        allowedSchemes: ['http', 'https', 'mailto'],
        allowedSchemesByTag: {
          img: ['http', 'https', 'data']
        },
        allowedSchemesAppliedToAttributes: ['href', 'src'],
        allowProtocolRelative: false,
        transformTags: {
          a: (tagName, attribs) => {
            const href = attribs.href || '';
            if (href && !this.isSafeHref(href)) {
              delete attribs.href;
            }
            attribs.class = 'saito-link';
            let isLocal = false;
            try {
              if (typeof window !== 'undefined' && window.location?.host) {
                isLocal = (attribs.href || href).includes(window.location.host);
              }
            } catch (err) {}
            if (isLocal) {
              attribs['data-link'] = 'local_link';
              delete attribs.target;
              delete attribs.rel;
            } else {
              attribs.target = '_blank';
              attribs.rel = 'noopener noreferrer';
            }
            return { tagName, attribs };
          }
        },
        exclusiveFilter: (frame) => {
          if (frame.tag !== 'img') {
            return false;
          }
          const src = frame.attribs?.src;
          if (!src || typeof src !== 'string') {
            return true;
          }
          const trimmed = src.trim();
          if (!trimmed || /[\s<>"'`]/.test(trimmed)) {
            return true;
          }
          if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
            return trimmed.includes('\\');
          }
          if (/^data:image\/(jpeg|jpg|png|gif|webp);base64,/i.test(trimmed)) {
            return false;
          }
          return !(this.isSafeHref(trimmed) && /^https?:/i.test(trimmed));
        }
      });

      text = emoji.emojify(text);

      text = text.replace(/^\s+|\s+$/g, '');

      return text;
    } catch (err) {
      console.error('Browser [sanitize] error: ', err);
      return '';
    }
  }

  async resizeImg(img, targetSize = 512, maxDimensions = { w: 1920, h: 1024 }) {
    let self = this;
    let dimensions = await this.getImageDimensions(img);
    let new_img = '';
    let canvas = document.createElement('canvas');
    let oImg = document.createElement('img');

    let w = dimensions.w;
    let h = dimensions.h;
    let aspect = w / h;

    if (w > maxDimensions.w) {
      w = maxDimensions.w;
      h = maxDimensions.w / aspect;
    }
    if (h > maxDimensions.h) {
      h = maxDimensions.h;
      w = maxDimensions.h * aspect;
    }

    canvas.width = w;
    canvas.height = h;

    let last_img_size = 1000000000000;

    function resizeLoop(img, quality = 1) {
      oImg.setAttribute('src', img);
      canvas.getContext('2d').drawImage(oImg, 0, 0, w, h);
      new_img = canvas.toDataURL('image/jpeg', quality);
      let imgSize = new_img.length / 1024; // in KB
      console.debug('Browser [resizeImg]: ' + imgSize);

      //Prevent infinite loops by seeing if the size is still going down
      if (imgSize > targetSize && imgSize < last_img_size) {
        last_img_size = imgSize;
        resizeLoop(new_img, quality * 0.9);
      } else {
        return;
      }
    }

    resizeLoop(img);

    oImg.remove();
    canvas.remove();

    console.info('Img Resized to: ' + new_img.length / 1024);

    return new_img;
  }

  getImageDimensions(file) {
    return new Promise(function (resolved, rejected) {
      let i = new Image();
      i.onload = function () {
        resolved({ w: i.width, h: i.height });
      };
      i.src = file;
    });
  }

  stripHtml(html) {
    if (this.app.BROWSER) {
      let tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    }

    return html.replace(/(<([^>]+)>)/gi, '');
  }

  //
  // This function should make strings friendly to put INSIDE an html tag
  // escaping special characters like & < > "
  //
  escapeHTML(text) {
    return sanitizer.escapeAttrib(text == null ? '' : String(text));
  }

  /**
   * Turn a bare autolink match into an absolute href, or null if the match
   * already has a non-allowed scheme (javascript:, data:, etc.).
   */
  hrefFromAutolink(url) {
    if (!url || typeof url !== 'string') {
      return null;
    }
    const trimmed = url.trim();
    if (!trimmed || /[\s<>"'`]/.test(trimmed)) {
      return null;
    }
    if (trimmed.startsWith('//')) {
      return null;
    }
    if (/^(https?|mailto):/i.test(trimmed)) {
      return trimmed;
    }
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed)) {
      return null;
    }
    return `http://${trimmed}`;
  }

  /**
   * True if url is safe to use as an href (http/https/mailto).
   * Rejects javascript:, data:, vbscript:, ftp, protocol-relative, and other non-allowed schemes.
   */
  isSafeHref(url) {
    if (!url || typeof url !== 'string') {
      return false;
    }
    const trimmed = url.trim();
    if (!trimmed || /[\s<>"'`]/.test(trimmed)) {
      return false;
    }
    if (trimmed.startsWith('//')) {
      return false;
    }
    const schemeMatch = trimmed.match(/^([a-zA-Z][a-zA-Z0-9+.-]*):/);
    if (!schemeMatch) {
      return false;
    }
    const scheme = schemeMatch[1].toLowerCase();
    return scheme === 'http' || scheme === 'https' || scheme === 'mailto';
  }

  /**
   * True if url is safe as an image/media src or CSS url().
   * Allows http(s), relative paths, and raster data:image base64 URLs. Rejects svg data URLs.
   */
  isSafeMediaUrl(url) {
    if (!url || typeof url !== 'string') {
      return false;
    }
    const trimmed = url.trim();
    if (!trimmed || /[\s<>"'`]/.test(trimmed)) {
      return false;
    }
    if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
      return !trimmed.includes('\\');
    }
    const lower = trimmed.toLowerCase();
    if (lower.startsWith('data:image/svg')) {
      return false;
    }
    if (/^data:image\/[a-z0-9.+-]+[;,]/i.test(trimmed)) {
      return true;
    }
    const schemeMatch = trimmed.match(/^([a-zA-Z][a-zA-Z0-9+.-]*):/);
    if (!schemeMatch) {
      return false;
    }
    const scheme = schemeMatch[1].toLowerCase();
    return scheme === 'http' || scheme === 'https';
  }

  //////////////////////
  // helper functions //
  //////////////////////
  filterText(text = '') {
    text = text.replace(/^\s+$/gm, '');
    text = text.replace(/^\n+$/gm, '');
    text = text.replace(/<div>\s*<br>\s*<\/div>\s*<div>\s*<br>\s*<\/div>/gm, '<div><br></div>');
    text = text.replace(/<div>\s*<br>\s*<\/div>$/gm, '');

    return text;
  }

  resolveModal() {
    if (this.modal_queue.length > 0) {
      console.log('Showing saved salert...');
      let next_modal = this.modal_queue.shift();
      salert(next_modal);
    }
  }

  attachWindowFunctions() {
    if (typeof window !== 'undefined') {
      let browser_self = this;

      let mutationThrottle = null;
      let mutatedNodes = [];
      let mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length > 0) {
            for (let m of mutation.addedNodes) {
              mutatedNodes.push(m);
            }
            if (mutationThrottle) {
              clearTimeout(mutationThrottle);
            }
            mutationThrottle = setTimeout(() => {
              browser_self.treatElements(mutatedNodes);
              browser_self.treatIdentifiers(mutatedNodes);
              mutatedNodes = [];
              mutationThrottle = null;
            }, 120);
          }
        });
      });

      mutationObserver.observe(document.documentElement, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
        attributeOldValue: true
      });

      window.sanitize = function (msg) {
        let result = browser_self.sanitize(msg);
        return result;
      };

      window.salert = function (message) {
        if (document.getElementById('saito-alert')) {
          return Promise.resolve(false);
        }
        return new Promise((resolve) => {
          let wrapper = document.createElement('div');
          wrapper.id = 'saito-alert';
          wrapper.className = 'saito-alert';
          let html = `<div id="saito-alert-shim">
                        <div id="saito-alert-box" class="saito-overlay-panel compact">
                          <div class="saito-alert-message">${browser_self.sanitize(message)}</div>
                          <div class="saito-button-row">
                            <button id="alert-ok" class="saito-button-primary">OK</button>
                          </div>
                        </div>
                      </div>`;
          wrapper.innerHTML = html;
          document.body.appendChild(wrapper);
          //        setTimeout(() => {
          //          document.querySelector("#saito-alert-box").style.top = "0";
          //        }, 100);
          document.querySelector('#alert-ok').focus();
          document.querySelector('#saito-alert-shim').addEventListener('keyup', function (event) {
            if (event.keyCode === 13) {
              event.preventDefault();
              document.querySelector('#alert-ok').click();
            }
          });
          document.querySelector('#alert-ok').addEventListener(
            'click',
            function () {
              wrapper.remove();
              resolve(true);
            },
            false
          );
          document.querySelector('#saito-alert-box').style.top = '1rem';
        });
      };

      window.sconfirm = function (message) {
        if (document.getElementById('saito-alert')) {
          return;
        }
        return new Promise((resolve, reject) => {
          let wrapper = document.createElement('div');
          wrapper.id = 'saito-alert';
          wrapper.className = 'saito-alert';
          let html = `<div id="saito-alert-shim">
                        <div id="saito-alert-box" class="saito-overlay-panel compact">
                          <div class="saito-alert-message">${browser_self.sanitize(message)}</div>
                          <div class="saito-button-row">
                            <button class='saito-button-secondary' id="alert-cancel">Cancel</button>
                            <button id="alert-ok" class="saito-button-primary">OK</button>
                          </div>
                        </div>
                      </div>`;
          wrapper.innerHTML = html;
          document.body.appendChild(wrapper);
          //          setTimeout(() => {
          //            document.getElementById("saito-alert-box").style.top = "0";
          //          }, 100);
          document.getElementById('alert-ok').focus();
          //document.getElementById('alert-ok').select();
          document.getElementById('saito-alert-shim').onclick = (event) => {
            if (event.keyCode === 13) {
              event.preventDefault();
              document.getElementById('alert-ok').click();
            }
          };
          document.getElementById('alert-ok').onclick = () => {
            wrapper.remove();
            resolve(true);
            // }, false;
          };
          document.getElementById('alert-cancel').onclick = () => {
            wrapper.remove();
            resolve(false);
            // }, false);
          };
          document.querySelector('#saito-alert-box').style.top = '1rem';
        });
      };

      window.sprompt = function (message, suggestion = '') {
        if (document.getElementById('saito-alert')) {
          return;
        }
        return new Promise((resolve, reject) => {
          let wrapper = document.createElement('div');
          wrapper.id = 'saito-alert';
          wrapper.className = 'saito-alert';
          let html = `<div id="saito-alert-shim">
                        <div id="saito-alert-box" class="saito-overlay-panel compact">
                          <div class="saito-alert-message">${browser_self.sanitize(message)}</div>
                          <div class="alert-prompt"><input type="text" id="promptval" class="promptval saito-input" placeholder="${suggestion}" /></div>
                          <div class="saito-button-row">
                            <button class='saito-button-secondary' id="alert-cancel">Cancel</button>
                            <button id="alert-ok" class="saito-button-primary">OK</button>
                          </div>
                        </div>
                      </div>`;
          wrapper.innerHTML = html;
          document.body.appendChild(wrapper);
          document.querySelector('#promptval').focus();
          document.querySelector('#promptval').select();
          //          setTimeout(() => {
          //            document.querySelector("#saito-alert-box").style.top = "0";
          //          }, 100);
          document.querySelector('#saito-alert-shim').addEventListener('keyup', function (event) {
            if (event.keyCode === 13) {
              event.preventDefault();
              document.querySelector('#alert-ok').click();
            }
          });
          document.querySelector('#alert-ok').addEventListener(
            'click',
            function () {
              let val = document.querySelector('#promptval').value || suggestion;
              wrapper.remove();
              resolve(val);
            },
            false
          );
          document.querySelector('#alert-cancel').addEventListener(
            'click',
            function () {
              wrapper.remove();
              resolve(false);
            },
            false
          );
          document.querySelector('#saito-alert-box').style.top = '1rem';
        });
      };

      window.siteMessage = function (message, killtime = 9999999, callback = null) {
        if (document.getElementById('site-message-wrapper')) {
          document.getElementById('site-message-wrapper').remove();
        }
        let wrapper = document.createElement('div');
        wrapper.id = 'site-message-wrapper';
        if (callback) {
          wrapper.classList.add('site-message-clickable');
        }
        wrapper.innerHTML = `<div class="site-message-message">${browser_self.sanitize(message)}</div>`;

        document.body.appendChild(wrapper);

        let timeout = setTimeout(() => {
          wrapper.classList.add('fade-out');
          timeout = setTimeout(() => {
            wrapper.remove();
          }, 500);
        }, killtime);

        document.querySelector('#site-message-wrapper').addEventListener(
          'click',
          () => {
            if (callback) {
              callback();
            }
            wrapper.remove();
            clearTimeout(timeout);
          },
          false
        );
      };

      window.ntfy = function (to, content) {
        content.topic = to;
        fetch('https://ntfy.hda0.net/', {
          method: 'POST',
          body: JSON.stringify(content)
        });
      };

      HTMLElement.prototype.destroy = function destroy() {
        try {
          this.parentNode.removeChild(this);
        } catch (err) {
          console.err('Browser [destroy] Error:', err);
        }
      };

      window.reloadWindow = this.reloadWindow;
      window.navigateWindow = this.navigateWindow.bind(this);
    }
  }

  siteMessage(message, killtime = 9999999, callback = null) {
    if (window) {
      siteMessage(message, (killtime = 9999999), (callback = null));
    }
  }

  treatElements(nodeList) {
    for (let node of nodeList) {
      if (node.files) {
        this.treatFiles(node);
      }

      if (node.classList) {
        if (node.classList.contains('saito-link')) {
          //Mark link as treated
          node.classList.add('saito-treated-link');
          node.classList.remove('saito-link');

          if (node.dataset.link) {
            node.addEventListener('click', (e) => {
              this.processLocalLink(e);
              e.stopPropagation();
            });
          }
        }
      }

      // Recurse!
      if (node.childNodes.length >= 1) {
        this.treatElements(node.childNodes);
      }
    }
  }

  treatIdentifiers(nodeList) {
    let unknown_keys = [];
    let saito_app = this.app;

    function treat(nodes) {
      nodes.forEach((el) => {
        if (el.classList) {
          if (el.classList.contains('saito-address') && !el.classList.contains('treated')) {
            el.classList.add('treated');
            let key = el.dataset?.id;
            if (key && saito_app.crypto.isPublicKey(key)) {
              // Returns registered name from our keychain or empty string
              let identifier = saito_app.keychain.returnIdentifierByPublicKey(key);

              if (identifier) {
                el.innerText = identifier;
                saito_app.browser.updateAddressHTML(key, identifier);
              } else {
                // Prettify anon key
                el.innerHTML = saito_app.keychain.returnUsername(key);

                // Gather keys to query register
                if (!unknown_keys.includes(key)) {
                  unknown_keys.push(key);
                }
              }
            }
          }
        }
        if (el.childNodes.length >= 1) {
          treat(el.childNodes);
        }
      });
    }

    treat(nodeList);
    if (unknown_keys.length > 0) {
      this.app.connection.emit('registry-fetch-identifiers-and-update-dom', unknown_keys);
    }
  }

  treatFiles(input) {
    if (input.classList.contains('treated')) {
      return;
    } else {
      input.addEventListener('change', function (e) {
        let fileName = '';
        if (this.files && this.files.length > 1) {
          fileName = this.files.length + ' files selected.';
        } else {
          fileName = e.target.value.split('\\').pop();
        }
        if (fileName) {
          filelabel.style.border = 'none';
          filelabel.innerHTML = sanitize(fileName);
        } else {
          //
          // What is labelVal supposed to be???
          //
          //filelabel.innerHTML = sanitize(labelVal);
        }
      });
      input.classList.add('treated');
      let filelabel = document.createElement('label');
      filelabel.classList.add('treated');
      filelabel.innerHTML = 'Choose File';
      filelabel.htmlFor = input.id;
      filelabel.id = input.id + '-label';
      let parent = input.parentNode;
      parent.appendChild(filelabel);
    }
  }

  processLocalLink(event) {
    event.preventDefault();

    let link = event.currentTarget.getAttribute('href');
    let processed = false;

    this.app.modules.getRespondTos('saito-link', { link }).forEach((modResponse) => {
      processed = true;
      modResponse.processLink(link);
    });

    if (!processed) {
      navigateWindow(link);
    }

    return false;
  }

  checkNFTThemes(): string[] | null {
    // Wallet-backed theme discovery will populate this list in a future release.
    return null;
  }

  isThemeAvailable(theme) {
    const nft_themes = this.checkNFTThemes();
    if (nft_themes === null) {
      return theme === 'dark';
    }

    return theme === 'dark' || (Array.isArray(nft_themes) && nft_themes.includes(theme));
  }

  switchTheme(theme) {
    let mod_obj = this.app.modules.returnActiveModule();
    let force_lite_for_game =
      mod_obj?.is_game_template === true || document.documentElement.classList.contains('game');

    if (force_lite_for_game) {
      theme = 'lite';
    } else if (!this.isThemeAvailable(theme)) {
      theme = 'dark';
    }

    document.documentElement.setAttribute('data-theme', theme);

    if (this.app.BROWSER == 1) {
      if (!this.app.options.theme) {
        this.app.options.theme = {};
      }

      if (mod_obj != null && !force_lite_for_game) {
        if (mod_obj.slug != null) {
          this.app.options.theme[mod_obj.slug] = theme;
          this.app.storage.saveOptions();
        }
      }
    }
  }

  isValidUrl(urlString) {
    try {
      let inputElement = document.createElement('input');
      inputElement.type = 'url';
      inputElement.value = urlString;

      if (!inputElement.checkValidity()) {
        return false;
      } else {
        return true;
      }
    } catch (err) {}
    return false;
  }

  updateSoftwareVersion(receivedBuildNumber: number) {
    console.info(
      `Received build number: ${Number(receivedBuildNumber)}, Current build number: ${
        this.app.build_number
      }`
    );
    if (receivedBuildNumber > this.app.build_number) {
      if (confirm(`Saito Upgrade: Upgrading to new version ${receivedBuildNumber}`)) {
        console.info(`New software update found: ${receivedBuildNumber}. Updating...`);
        siteMessage(`New software update found: ${receivedBuildNumber}. Updating...`);
        /*let target = window.location.href;
        target += target.includes('?') ? '&' : '?';
        target += 'build=' + receivedBuildNumber;
        navigateWindow(target, 1000);*/
        reloadWindow(1000);
      }
    }
  }

  getDecimalSeparator() {
    let locale =
      this.app.BROWSER && window?.navigator?.language ? window.navigator.language : 'en-US';
    const numberWithDecimalSeparator = 1.1;
    return Intl.NumberFormat(locale)
      .formatToParts(numberWithDecimalSeparator)
      .find((part) => part.type === 'decimal').value;
  }

  getThousandSeparator() {
    return this.getLocaleNumberSeparators().group;
  }

  /**
   * Format a number to locale string
   * @returns String
   * @param number
   */

  formatNumberToLocale(number) {
    try {
      const locale =
        this.app.BROWSER && window?.navigator?.language ? window.navigator.language : 'en-US';
      const numberFormatter = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 1,
        // maximumFractionDigits: 4,
        minimumSignificantDigits: 1
        // maximumSignificantDigits: 4
      });
      return numberFormatter.format(number);
    } catch (err) {
      console.error('Browser [formatNumber] Error: ', err);
      return number;
    }
  }

  getLocaleNumberSeparators(locale = null) {
    const resolvedLocale =
      locale ||
      (this.app.BROWSER && window?.navigator?.language ? window.navigator.language : 'en-US');
    const parts = Intl.NumberFormat(resolvedLocale).formatToParts(12345.6);
    return {
      locale: resolvedLocale,
      decimal: parts.find((part) => part.type === 'decimal')?.value || '.',
      group: parts.find((part) => part.type === 'group')?.value || ''
    };
  }

  parseLocaleAmount(value = '', options: any = {}) {
    const maxFractionDigits =
      Number.isFinite(options.maxFractionDigits) && options.maxFractionDigits >= 0
        ? options.maxFractionDigits
        : 8;
    const allowNegative = options.allowNegative === true;
    const strictLocaleSeparators = options.strictLocaleSeparators === true;
    const { decimal, group } = this.getLocaleNumberSeparators(options.locale || null);
    let input = String(value ?? '').trim();

    if (!input) {
      return { valid: false, normalized: '', value: null, fractionDigits: 0 };
    }

    input = input
      .replace(/[\s\u00a0\u202f]/g, '')
      .replace(/[’']/g, '')
      .replace(/[−–—]/g, '-');

    let negative = false;
    if (input.startsWith('-')) {
      negative = allowNegative;
      input = input.slice(1);
    }

    if (!/\d/.test(input)) {
      return { valid: false, normalized: '', value: null, fractionDigits: 0 };
    }

    const dotPositions = [];
    const commaPositions = [];
    for (let i = 0; i < input.length; i++) {
      if (input[i] === '.') {
        dotPositions.push(i);
      } else if (input[i] === ',') {
        commaPositions.push(i);
      }
    }

    const allDecimalCandidates = [...dotPositions, ...commaPositions].sort((a, b) => a - b);
    let decimalIndex = -1;
    let decimalChar = decimal;

    if (allDecimalCandidates.length) {
      const last = allDecimalCandidates[allDecimalCandidates.length - 1];
      const lastChar = input[last];
      const after = input.slice(last + 1).replace(/\D/g, '');
      const before = input.slice(0, last).replace(/\D/g, '');
      const sameCharCount = lastChar === '.' ? dotPositions.length : commaPositions.length;
      const otherCharCount = lastChar === '.' ? commaPositions.length : dotPositions.length;
      const localeDecimalMatch = lastChar === decimal;
      const localeGroupMatch = group && lastChar === group;

      if (strictLocaleSeparators && localeGroupMatch) {
        decimalIndex = -1;
      } else if (otherCharCount > 0) {
        decimalIndex = last;
        decimalChar = lastChar;
      } else if (localeDecimalMatch) {
        decimalIndex = last;
        decimalChar = lastChar;
      } else if (sameCharCount > 1) {
        if (after.length > 0 && after.length !== 3) {
          decimalIndex = last;
          decimalChar = lastChar;
        }
      } else if (localeGroupMatch && after.length === 3 && before.length > 0) {
        decimalIndex = -1;
      } else if (after.length > 0 && after.length <= maxFractionDigits) {
        decimalIndex = last;
        decimalChar = lastChar;
      }
    }

    let whole = '';
    let fraction = '';
    for (let i = 0; i < input.length; i++) {
      const ch = input[i];
      if (i === decimalIndex) {
        continue;
      }
      if (/\d/.test(ch)) {
        if (decimalIndex >= 0 && i > decimalIndex) {
          fraction += ch;
        } else {
          whole += ch;
        }
      }
    }

    whole = whole.replace(/^0+(?=\d)/, '') || '0';
    fraction = fraction.slice(0, maxFractionDigits);

    if (maxFractionDigits === 0) {
      fraction = '';
    }

    const normalized = `${negative ? '-' : ''}${whole}${fraction ? `.${fraction}` : ''}`;
    const numeric = Number(normalized);
    return {
      valid: Number.isFinite(numeric),
      normalized,
      value: Number.isFinite(numeric) ? numeric : null,
      fractionDigits: fraction.length,
      hadTrailingDecimal: decimalIndex === input.length - 1 || input.endsWith(decimalChar)
    };
  }

  formatLocaleAmount(value = '', options: any = {}) {
    const maxFractionDigits =
      Number.isFinite(options.maxFractionDigits) && options.maxFractionDigits >= 0
        ? options.maxFractionDigits
        : 8;
    const { locale, decimal } = this.getLocaleNumberSeparators(options.locale || null);
    const parsed = this.parseLocaleAmount(value, { ...options, maxFractionDigits });

    if (!parsed.valid) {
      return '';
    }

    const [wholeRaw, fractionRaw = ''] = parsed.normalized.replace('-', '').split('.');
    const whole = BigInt(wholeRaw || '0').toLocaleString(locale);
    const sign = parsed.normalized.startsWith('-') ? '-' : '';
    const fraction = fractionRaw.slice(0, maxFractionDigits);

    if (fraction || parsed.hadTrailingDecimal) {
      return `${sign}${whole}${decimal}${fraction}`;
    }

    return `${sign}${whole}`;
  }

  formatLocaleAmountInputElement(input, options: any = {}) {
    if (!input) {
      return { valid: false, normalized: '', value: null, fractionDigits: 0 };
    }

    const parsed = this.parseLocaleAmount(input.value, options);
    input.dataset.amountRaw = parsed.valid ? parsed.normalized : '';

    if (parsed.valid) {
      input.value = this.formatLocaleAmount(input.value, options);
    }

    return parsed;
  }

  addSaitoMentions(textarea, listDiv, inputType) {
    new SaitoMentions(this.app, textarea, listDiv, inputType);
  }

  extractMentions(text) {
    let potential_keys = text.matchAll(/(?<=^|(?<=[^a-zA-Z0-9-_\.]))@([^\s]+)/g);
    let keys = [];

    for (let k of potential_keys) {
      let split = k[0].split('@');
      let username = '';
      let key = '';

      if (split.length > 2) {
        username = split[1] + '@' + split[2];
        key = this.app.keychain.returnPublicKeyByIdentifier(username);
      } else {
        username = this.app.keychain.returnUsername(split[1]);
        key = split[1];
      }

      if (this.app.crypto.isPublicKey(key)) {
        if (!keys.includes(key)) {
          keys.push(key);
        }
      }
    }

    return keys;
  }

  markupMentions(text) {
    return text.replaceAll(/(?<=^|(?<=[^a-zA-Z0-9-_\.]))@([^\s]+)/g, (k) => {
      let split = k.split('@');
      let username = '';
      let key = '';

      if (split.length > 2) {
        username = split[1] + '@' + split[2];
        key = this.app.keychain.returnPublicKeyByIdentifier(username);
      } else {
        username = this.app.keychain.returnUsername(split[1]);
        key = split[1];
      }

      if (this.app.crypto.isPublicKey(key)) {
        return `<span class="saito-mention saito-address" data-id="${this.escapeHTML(key)}">${this.escapeHTML(username)}</span>`;
      } else {
        return k;
      }
    });
  }

  validateAmountLimit(amount, event) {
    // allow only numbers, dot, backspace
    // 95 to 106 corresponds to Numpad 0 through 9;
    // 47 to 58 corresponds to 0 through 9 on the Number Row;
    // 8 is Backspace
    // 190, 110, 46 are for dot (.)
    if (!(
      (event.keyCode > 95 && event.keyCode < 106) ||
      (event.keyCode > 47 && event.keyCode < 58) ||
      event.keyCode == 8 ||
      event.keyCode == 190 ||
      event.keyCode == 110 ||
      event.keyCode == 46
    )) {
      event.preventDefault();
      return false;
    }

    // prevent user for adding number gretaer than 10^9 to input
    if (amount > 1000000000) {
      if (!isNaN(event.key)) {
        event.preventDefault();
        return false;
      }
    }

    // prevent user for adding more than 8 decimal point precision
    let amount_string = amount.toString();
    let decimal_separator = this.app.browser.getDecimalSeparator();

    if (amount_string.indexOf(decimal_separator)) {
      let myArray = amount.split(decimal_separator);
      if (typeof myArray[1] != 'undefined') {
        let decimal_value = myArray[1];
        if (decimal_value.length > 8) {
          if (!isNaN(event.key)) {
            event.preventDefault();
            return false;
          }
        }
      }
    }
  }

  // from saito/wallet.ts
  formatDecimals(balance, exact_precision = false) {
    if (typeof balance == 'undefined') {
      balance = '0.00';
    }

    let balance_as_float = parseFloat(balance);
    let abs_val = Math.abs(balance_as_float);
    //
    // Exact precision, override default and allow up to 8 digits
    //
    let maximumFractionDigits = 8;
    let minimumFractionDigits = 0;

    //
    // Inexact -- give more or less fractional digits based on total significant digits...
    //
    if (!exact_precision) {
      maximumFractionDigits = 6;
      minimumFractionDigits = 4;

      if (abs_val >= 1) {
        maximumFractionDigits = 5;
      }

      if (abs_val >= 10) {
        minimumFractionDigits = 3;
        maximumFractionDigits = 4;
      }

      if (abs_val >= 100) {
        minimumFractionDigits = 2;
        maximumFractionDigits = 3;
      }

      if (abs_val >= 1000) {
        minimumFractionDigits = 1;
      }

      if (abs_val >= 10000) {
        maximumFractionDigits = 2;
      }

      if (abs_val >= 100000) {
        minimumFractionDigits = 0;
      }

      if (abs_val >= 1000000) {
        maximumFractionDigits = 1;
      }
    }

    let options = {
      minimumFractionDigits,
      maximumFractionDigits
    };

    let locale = (this.app.BROWSER && window?.navigator?.language) || 'en-US';
    let nf = new Intl.NumberFormat(locale, options);

    return nf.format(balance_as_float).toString();
  }

  returnBalanceHTML(balance, exact_precision) {
    balance = this.formatDecimals(balance, exact_precision);
    let separator = this.getDecimalSeparator();

    let split = balance.split(`${separator}`);

    let html = `<span class="balance-amount-whole">${split[0]}</span>`;

    if (split[1]) {
      html += `<span class="balance-amount-separator">${separator}</span>`;
      html += `<span class="balance-amount-decimal">${split[1]}</span>`;
    }

    return html;
  }

  logoSVG() {
    return `<svg class="saito-header-logo" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 381 134">
      <title>Saito Logo</title>
      <path class="cls-1" d="M113.49,34.26,59,2.77h0a1.56,1.56,0,0,0-.39-.15h-.07a1.47,1.47,0,0,0-.82.11l-.07,0-.06,0L3.11,34.18h0L3,34.26a1.43,1.43,0,0,0-.72,1.24v63A1.42,1.42,0,0,0,3,99.73l54.54,31.49a1.45,1.45,0,0,0,.72.2,1.42,1.42,0,0,0,.72-.2l54.54-31.49a1.41,1.41,0,0,0,.69-1c0-.05,0-.1,0-.15s0-.08,0-.12v-63A1.43,1.43,0,0,0,113.49,34.26ZM56.8,127.5,5.59,97.93,31.67,53.24,56.8,67.82V127.5ZM5.12,37.83l24.07,14L5.12,93.05Zm54.55,30L61.14,67,86.72,52.2,111.34,38V97l-51.67,0ZM86.52,49,65.58,13.62,62.25,8,109.91,35.5ZM57.72,6,84,50.44l-15.56,9L58.23,65.34,6.69,35.43Zm2,94,47.82,0L59.67,127.5Z"/>
      <path class="cls-1" d="M163.64,79l-13.29,7.67c3.29,10.79,13.84,17.88,27.55,17.88,15.59,0,27.88-9,27.88-24.27,0-14.36-10.53-19.62-22.52-22.52l-2.66-.64c-8.13-2-13.44-3.91-13.44-8.86,0-4,3.82-6.61,9.29-6.61,6.76,0,10.73,3.81,11.83,9.92l1.23.4,11.87-6.85c-3.16-8.87-11.36-14.92-24.72-14.92-14,0-24.48,7.12-24.48,19,0,8.64,5.06,13.69,12.78,16.95a55.53,55.53,0,0,0,8.7,2.77c1.81.43,3.56.85,5.18,1.31,6.66,1.88,11.45,4.45,11.45,11.09s-4.86,10.22-11.57,10.22c-7.27,0-12.9-4.22-14-12.2Z"/>
      <path class="cls-1" d="M261.37,92.55a4.71,4.71,0,0,1-2,.32c-2.27,0-3.72-1.55-3.72-4.86V69.53c0-12.19-9.29-18.69-22-18.69-10.74,0-19.21,5.37-21.38,15.9l.52.62,12.18,1c.62-4.33,3.62-7.12,8.47-7.12,5.37,0,8.47,2.68,8.47,7.43V71L228,72.42c-11.15,1.13-18.17,6.91-18.17,16.41,0,9.82,7.64,15.71,16.41,15.71,6.92,0,11.67-2.79,16.22-7.45h.72c2.37,5.28,6.92,7,11.57,7a22.2,22.2,0,0,0,7.12-1V93.17ZM242,86c-3.72,4.76-7.22,7.55-12.39,7.55-3.61,0-6.4-2.07-6.4-5.58s2.58-5.89,7.43-6.51L242,80.05Z"/>
      <rect class="cls-1" x="266.72" y="51.87" width="14.46" height="51.63"/>
      <path class="cls-1" d="M274,29.46a8.37,8.37,0,1,0,8.36,8.36A8.46,8.46,0,0,0,274,29.46Z"/>
      <path class="cls-1" d="M309.49,63.85V87.6c0,3.41,2.07,5.16,5.57,5.16A13.17,13.17,0,0,0,319.2,92l.72.42v11a36.12,36.12,0,0,1-9.08,1c-9.2,0-15.71-4.75-15.71-15.69v-25H286v-12h9.18V39.05l13-7.53h1.33V51.87h10.95v12Z"/>
      <path class="cls-1" d="M350.56,50.84c-16.42,0-28.09,11.46-28.09,26.84s11.67,26.86,28.09,26.86,28.19-11.47,28.19-26.86S367.08,50.84,350.56,50.84Zm0,41.2c-7.85,0-13.63-5.38-13.63-14.36s5.78-14.35,13.63-14.35,13.73,5.37,13.73,14.35S358.4,92,350.56,92Z"/></svg>`;
  }

  reloadWindow(delay = 0) {
    if (delay > 0) {
      setTimeout(() => {
        if (this) {
          this.page_navigation_active = true;
        }
        window.location.reload();
      }, delay);
    } else {
      if (this) {
        this.page_navigation_active = true;
      }

      window.location.reload();
    }
  }

  beforeUnloadHandler(event) {
    event.preventDefault();
    event.returnValue = true;
  }

  lockNavigation(callback, beforeUnload = false) {
    this.navigation_locked = true;

    if (beforeUnload) {
      window.addEventListener('beforeunload', this.beforeUnloadHandler);
    }

    window.addEventListener(this.terminationEvent, callback);
    if (this.app.browser.isMobileBrowser()) {
      document.addEventListener('visibilitychange', callback);
    }
  }

  unlockNavigation(callback) {
    this.navigation_locked = false;

    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    window.removeEventListener(this.terminationEvent, callback);
    if (this.app.browser.isMobileBrowser()) {
      document.removeEventListener('visibilitychange', callback);
    }
  }

  async navigateWindow(target, delay = 0) {
    if (this.navigation_locked) {
      let c = await sconfirm('Are you sure you want to leave this page?');
      if (!c) {
        return;
      }
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    }

    if (delay > 0) {
      setTimeout(() => {
        this.page_navigation_active = true;
        window.location.href = target;
      }, delay);
    } else {
      this.page_navigation_active = true;
      window.location.href = target;
    }
  }

  safeConsole(header, ui_component, log_level = '') {
    const getCircularReplacer = () => {
      const seen = new WeakSet();
      return (key, value) => {
        if (key == 'mod' || key == 'app') {
          return undefined;
        }
        if (typeof value === 'object' && value !== null) {
          if (seen.has(value)) {
            //console.warn('JSON.Stringify -- Circular reference found at key:', key); // Log the key
            return; // Discard the circular reference
          }
          seen.add(value);
        }
        return typeof value === 'bigint' ? value.toString() : value; // return everything else unchanged
      };
    };

    let new_obj = JSON.parse(JSON.stringify(ui_component, getCircularReplacer()));

    switch (log_level) {
      case 'debug':
        console.debug(header, new_obj);
        break;
      case 'info':
        console.info(header, new_obj);
        break;
      case 'warn':
        console.warn(header, new_obj);
        break;
      case 'error':
        console.error(header, new_obj);
        break;
      default:
        console.log(header, new_obj);
    }
  }

  handleShare(data) {
    // Use Web Share API if available, otherwise fall back to copy
    if (this.isMobileBrowser() && navigator.share) {
      navigator.share(data).catch((err) => {
        // User cancelled or error - fall back to copy
        this.handleCopyLink(data?.url);
      });
    } else {
      // Fall back to copy link
      this.handleCopyLink(data?.url);
    }
  }

  handleCopyLink(shareUrl = window.location.href) {
    // Copy to clipboard
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(shareUrl)
        .then(() => {
          if (typeof siteMessage === 'function') {
            siteMessage('Link copied to clipboard', 1500);
          }
        })
        .catch((err) => {
          console.error('Failed to copy:', err);
          this.fallbackCopy(shareUrl);
        });
    } else {
      this.fallbackCopy(shareUrl);
    }
  }

  fallbackCopy(text) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      if (typeof siteMessage === 'function') {
        siteMessage('Link copied to clipboard', 1500);
      }
    } catch (err) {
      console.error('Fallback copy failed:', err);
      if (typeof siteMessage === 'function') {
        siteMessage('Failed to copy link', 1500);
      }
    }

    document.body.removeChild(textArea);
  }

  /**
   * Creates a container div and renders a React component into it
   * @param Component The React component to render
   * @param props Props to pass to the component
   * @param containerId Optional custom container ID (default: auto-generated)
   * @returns Object containing the container element, root instance, and cleanup function
   */
  createReactRoot(
    Component: React.ComponentType<any>,
    props: Record<string, any> = {},
    containerId?: string
  ) {
    const id = containerId || `saito-react-root-${Date.now()}`;
    const container = document.createElement('div');
    container.id = id;
    document.body.appendChild(container);

    const root = createRoot(container);
    root.render(React.createElement(Component, props));

    const cleanup = () => {
      root.unmount();
      container.remove();
    };

    return {
      container,
      root,
      cleanup
    };
  }

  //
  // convenience function, used in scripting, put here so it
  // will be available on for the OPCODEs on the app.* structure
  //
  // it takes a value, and an object and either extracts the
  // value from the object (if exists) or returns the string
  //
  resolveVarReference(vars, value) {
    if (typeof value !== 'string') {
      return value;
    }
    const parts = value.split('.');
    let cursor = vars;
    for (let key of parts) {
      if (
        cursor &&
        typeof cursor === 'object' &&
        Object.prototype.hasOwnProperty.call(cursor, key)
      ) {
        cursor = cursor[key];
      } else {
        return value; // fail closed: treat as literal
      }
    }
    return cursor;
  }
}

export default Browser;
